export const state = () => ({
  menus: [],
  hoveredSubmenuIndex: null
})

export const actions = {
  async getMenubars({ commit, rootState }) {
    const theme = this.$config.THEME
    const language = this.$cookie.get('wl_locale')
    try {
      const response = await this.$axios(
        `cms/lnd/menubar-contents?currency=${rootState.settings.defaultCurrency}&theme_code=${theme}&language=${language}`,
        {
          retry: 5,
          retryDelay: 500
        }
      )
      commit('setMenubars', response?.data)
      return response.data
    } catch (error) {}
  }
}

export const mutations = {
  setMenubars(state, menus) {
    if (!menus.length) return
    // Sort main menu and sub menu sequence
    const sortedMenubars = menus.sort((a, b) => ~~a?.sequence - ~~b?.sequence)
    sortedMenubars.forEach(menu => {
      menu?.items.sort((a, b) => a?.sequence - b?.sequence)
    })
    state.menus = sortedMenubars
  },
  setHoveredSubmenuIndex: (state, index) => {
    state.hoveredSubmenuIndex = index
  }
}
